var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M601,673l-2-2,8-9,2,2Zm-4,0,1-1,2,2-1,1h-2v-2Zm-3,4h12v-7h2v9H592V662h11v2h-9v13Z","transform":"translate(-592 -662)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }